import React from 'react'

export const TranscriptIllustration = () => {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M34.2131 0.355957H30.6875V7.52476H34.2131V0.355957Z"
                fill="currentColor"
            />
            <path
                d="M43.6116 0.355957H40.0859V7.52476H43.6116V0.355957Z"
                fill="currentColor"
            />
            <path
                d="M24.8069 0.355957H21.2812V7.52476H24.8069V0.355957Z"
                fill="currentColor"
            />
            <path
                d="M15.4085 0.355957H11.8828V7.52476H15.4085V0.355957Z"
                fill="currentColor"
            />
            <path
                d="M7.4188 21.3926H0.25V24.9182H7.4188V21.3926Z"
                fill="currentColor"
            />
            <path
                d="M7.4188 11.9907H0.25V15.5164H7.4188V11.9907Z"
                fill="currentColor"
            />
            <path
                d="M7.4188 30.7939H0.25V34.3196H7.4188V30.7939Z"
                fill="currentColor"
            />
            <path
                d="M7.4188 40.1958H0.25V43.7214H7.4188V40.1958Z"
                fill="currentColor"
            />
            <path
                d="M24.8069 48.187H21.2812V55.3558H24.8069V48.187Z"
                fill="currentColor"
            />
            <path
                d="M15.4085 48.187H11.8828V55.3558H15.4085V48.187Z"
                fill="currentColor"
            />
            <path
                d="M34.2131 48.187H30.6875V55.3558H34.2131V48.187Z"
                fill="currentColor"
            />
            <path
                d="M43.6116 48.187H40.0859V55.3558H43.6116V48.187Z"
                fill="currentColor"
            />
            <path
                d="M55.2469 30.7939H48.0781V34.3196H55.2469V30.7939Z"
                fill="currentColor"
            />
            <path
                d="M55.2469 40.1958H48.0781V43.7214H55.2469V40.1958Z"
                fill="currentColor"
            />
            <path
                d="M55.2469 21.3926H48.0781V24.9182H55.2469V21.3926Z"
                fill="currentColor"
            />
            <path
                d="M55.2469 11.9907H48.0781V15.5164H55.2469V11.9907Z"
                fill="currentColor"
            />
            <path
                d="M16.5234 39.166H38.9739V16.5464H16.5234V39.166ZM34.6817 33.9472H32.1058V25.6799H34.6817V33.9472ZM33.3937 21.7652C34.2152 21.7652 34.8353 22.3888 34.8402 23.2176C34.8508 23.6052 34.7136 23.966 34.4537 24.235C34.1798 24.5182 33.7923 24.674 33.362 24.674C32.5598 24.674 31.9314 24.0387 31.9314 23.2275C31.9313 22.4074 32.5738 21.7652 33.3937 21.7652ZM23.981 22.076H26.4911L30.5422 33.9471H27.8195L26.6774 30.5843H23.7355L22.6251 33.9471H19.9474L23.981 22.076Z"
                fill="currentColor"
            />
            <path
                d="M25.2059 26.0281C25.2035 26.0211 25.2011 26.0139 25.1988 26.0068L24.4141 28.3254H25.9877L25.2059 26.0281Z"
                fill="currentColor"
            />
            <path
                d="M7.42969 7.40723V48.3047H48.0628V7.40723H7.42969ZM42.5175 40.9387C42.5175 41.9178 41.7236 42.7117 40.7444 42.7117H14.748C13.7688 42.7117 12.9749 41.9178 12.9749 40.9387V14.7732C12.9749 13.794 13.7688 13.0002 14.748 13.0002H40.7445C41.7237 13.0002 42.5176 13.794 42.5176 14.7732V40.9387H42.5175Z"
                fill="currentColor"
            />
        </svg>
    )
}
